import { render, staticRenderFns } from "./IconArrowBack.vue?vue&type=template&id=6f64f8e6&"
import script from "./IconArrowBack.vue?vue&type=script&lang=ts&"
export * from "./IconArrowBack.vue?vue&type=script&lang=ts&"
import style0 from "./IconArrowBack.vue?vue&type=style&index=0&id=6f64f8e6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports